<template>
  <div class="toast hide border-2 rounded-3" role="alert" aria-live="assertive" aria-atomic="true">
    <div class="d-flex">
      <slot />
      <button v-if="!autohide" type="button" class="btn-close me-2 m-auto" data-coreui-dismiss="toast" aria-label="Close" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Toast",
  props: {
    autohide: {
      type: Boolean,
      default: true,
    },
    delay: {
      type: Number,
      default: 5000,
    },
  },
  data() {
    return {
      toast: null,
    }
  },
  inject: [
    '$toast'
  ],
  methods: {
    show() {
      if (this.toast === null) {
        this.toast = new this.$toast(this.$el, {autohide: this.autohide, delay: this.delay});
      }
      this.toast.show();
    },
    hide() {
      if (this.toast === null) {
        this.toast = new this.$toast(this.$el, {autohide: this.autohide, delay: this.delay});
      }
      this.toast.hide();
    },

  },
}
</script>
